<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h4 class="card-label">Review notes</h4>
    </div>
    <div class="card-toolbar">
      <button mat-button mat-raised-button color="primary" (click)="onSave()" class="mr-2">
        Save
      </button>
      <button mat-button mat-raised-button color="warn" (click)="onClose()" style="background-color: orange; color: white">
				<span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="card-body pt-0 w-100">
    <div class="d-flex align-items-center w-full mt-10" *ngFor="let group of formArray.controls; let i = index">
      <div style="flex: 1">
        <div class="row" [formGroup]="group">
          <div class="col-12 d-flex justify-content-end">
            <span
              ngbPopover="Mark this issue as resolved (or not)"
              triggers="mouseenter:mouseleave"
            >
              <mat-checkbox formControlName="status">
                Status
              </mat-checkbox>
            </span>
          </div>
          <div class="col-12">
            <mat-form-field class="mat-form-field-fluid">
              <textarea matInput [placeholder]="'Note ' + (i + 1)" formControlName="text"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="flex-shrink: 0; width: 60px;" *ngIf="data.isReviewer">
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button type="button" mat-icon-button color="primary" (click)="onAddNote()">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button type="button" mat-icon-button color="warn" (click)="onRemoveNote(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>